// extracted by mini-css-extract-plugin
module.exports = {"container":"PageLayout_container__3S-26","headingExtra":"PageLayout_headingExtra__2e8kR","heading":"PageLayout_heading___tAyV","description":"PageLayout_description__zyWZ2"};